import React, { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Typography, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  card: {
    backgroundImage: "none",
    width: "300px",
    height: "170px",
    paddingTop: "42px",
    paddingBottom: "40px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginTop: "20px",
    fontSize: "15px",
    "&:hover": {
      color: "white",
      backgroundSize: "cover",
      backgroundColor: "#2c387e",
      boxShadow:
        "rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px",
    },
  },
});

const CardComp = ({ name, position, desc }) => {
  const classes = useStyles();
  const [descOn, setDescOn] = useState(false);
  const mouseEnter = () => {
    setDescOn(true);
  };
  const mouseLeave = () => {
    setDescOn(false);
  };
  return (
    <div onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
      <Card className={classes.card}>
        <CardContent sx={{ pb: 2 }}>
          {descOn ? (
            <div>{desc}</div>
          ) : (
            <div>
              <Box sx={{ fontWeight: "bold", fontSize: "20px" }}>{name}</Box>

              <Typography sx={{ paddingTop: "10px", lineHeight: "120%" }}>
                {position}
              </Typography>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default CardComp;
